<template>
    <Dialog 
        v-model:visible="internalVisible" 
        modal 
        :draggable="false" 
        :closable="false" 
        :header="props.title" 
        :style="{ width: '25rem' }" 
        class="ml-2 me-2"
    >
        <span class="p-text-secondary block mb-5">{{ props.text }}!</span>
        
        <div 
            class="flex w-full gap-2 content-center mt-10 primary-button grow-effect rounded-3xl px-4 shadow"
            @click.prevent="closeDialog()"
        >
            <span class="text-lg lg:text-lg 2xl:text-2xl my-auto text-silver font-semibold mx-auto md:mx-0">
                {{ translationHandler.translate(props.okButtonText, 'ucfirst') }}
            </span>
            <i class="ml-auto text-silver pi pi-check-square border border-second-color rounded-full bg-second-color p-2 my-auto shadow"></i>
        </div>
    </Dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import translationHandler from "@/composables/handlers/TranslationHandler";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    text: {
        type: String,
        required: true,
    },
    visible: {
        type: Boolean,
        required: true,
        default: false,
    },
    okButtonText: {
        type: String,
        required: false,
        default: 'ok',
    },
});

const emit = defineEmits(['update:visible']);
const internalVisible = ref(props.visible);

watch(() => props.visible, (newValue) => {
    internalVisible.value = newValue;
});

watch(internalVisible, (newValue) => {
    if (!newValue) {
        emit('update:visible', false);
    }
});

function closeDialog() {
    internalVisible.value = false;
}
</script>